import * as $ from 'jquery';
import Debouncer from '../../scripts/lib/Debouncer';

export default class DetailSummaryGroup {
	constructor() {
		let $previouslyClickedHeading:JQuery;
		let $heading = $('.detailSummary__heading');
		let imageHeight = '';

		$('.detail').slideUp(0);

		$heading.toggleClass('settingUp isClosed');
		$heading.on('click', clickHandler);

		let timeout = window.setTimeout(function(){
			$heading.removeClass('settingUp');
		}, 100);


		// if FAQs are beside image, stop expanded accordions from enlarging image (due to flexbox)
		let $imageWrapper = $('.detailSummaryGroup__responsiveImage');
		if ($imageWrapper.length > 0) {
			setImageHeight();
			let setImageHeightDebounced = (new Debouncer(setImageHeight, false, 200)).run;
			window.addEventListener('resize', setImageHeightDebounced);
		}

		function clickHandler(event: Event) {
			let oneAtATimeGroup = $(this).parents('.detailSummaryGroup--oneAtATime');
			if (oneAtATimeGroup.length > 0) {
				if ($previouslyClickedHeading !== undefined && $previouslyClickedHeading[0] === $(this)[0]) {
					oneAtATimeGroup.find($heading).not($previouslyClickedHeading).addClass('isClosed');
				} else {
					oneAtATimeGroup.find($heading).addClass('isClosed');
				}
				oneAtATimeGroup.find('.detail').slideUp();
			}

			$(this).toggleClass('isClosed');
			$(this).siblings('.detail').stop().slideToggle();

			$previouslyClickedHeading = $(this);
		}
		function setImageHeight() {
			$imageWrapper.each(function(index, element) {
				let $element = $(element);
				$element.css('height', '');

				if ($element.is(':visible')) {
					imageHeight = $element.css("height");
					$element.css("height", imageHeight);
				}
			});
		}
	}
};
